import Vue from 'vue'

Vue.component('text-input', {
  props: {
    name: String,
    label: String,
    type: {
      type: String,
      default: 'text'
    },
    modifier: {
      type: String,
      default: 'default'
    },
    autocorrect: Boolean,
    autocapitalize: Boolean,
    initialValueGetter: Function,
    placeholder: String,
    error: String,
    required: Boolean,
    validateMethod: Function,
    enableToggle: {
      type: Boolean,
      default: false
    },
    showLabel: {
      type: String,
      default: 'Show'
    },
    hideLabel: {
      type: String,
      default: 'Hide'
    }
  },
  data () {
    const data = {
      isValid: true,
      isActive: false,
      showErrorMessage: false,
      dirty: false,
      revealed: false,
      currentType: this.type
    }

    if (this.initialValueGetter && this.initialValueGetter.bind !== 'undefined') {
      data.inputValue = this.initialValueGetter(this.name)
    } else {
      data.inputValue = ''
    }

    return data
  },
  computed: {
    hasPasswordToggle () {
      return this.enableToggle && this.type === 'password'
    },
    toggleLabel () {
      return this.revealed ? this.hideLabel : this.showLabel
    },
    resolvedError () {
      return this.resolveMessage(this.error)
    }
  },
  watch: {
    inputValue () {
      if (!this.dirty) this.dirty = true

      this.validateInput()

      this.$emit('change', {
        value: this.inputValue,
        name: this.name
      })
    }
  },
  mounted () {
    this.$emit('change', {
      value: this.inputValue,
      name: this.name
    })
    if (this.inputValue) this.setActive()
  },
  methods: {
    validateInput () {
      if (this.validateMethod) {
        const response = this.validateMethod({
          value: this.inputValue,
          name: this.name
        })
        this.isValid = response.valid
      } else if (this.required && !this.inputValue) {
        this.isValid = false
      } else {
        this.isValid = true
      }
      return this.isValid
    },
    setActive () {
      this.isActive = true
    },
    unsetActive () {
      if (!this.inputValue) this.isActive = false
    },
    refresh () {
      setTimeout(() => {
        this.inputValue = this.$refs.input.value
        if (this.inputValue) this.setActive()
      }, 0)
    },
    resolveMessage (message) {
      if (!message || typeof message !== 'string') return message
      if (!message.includes('.')) return message

      const translated = this.$t(message)
      return translated === message ? message : translated
    },
    togglePassword () {
      if (!this.hasPasswordToggle) return
      this.revealed = !this.revealed
      this.currentType = this.revealed ? 'text' : 'password'
    }
  },
  template: `
  <div class="text-input" :class="[ 'text-input--'+modifier, (!isValid && dirty)?'form-row__error': '', isActive ? 'is-active' : '', hasPasswordToggle ? 'text-input--has-toggle' : '' ]">
    <label class="text-input__label">
      <span>{{ label ? label : placeholder }}</span>
    </label>

    <div class="text-input__wrapper">
      <input
        ref="input"
        class="text-input__el p1"
        :type="hasPasswordToggle ? currentType : type"
        :name="name"
        :autocorrect="autocorrect"
        :autocapitalize="autocapitalize"
        :placeholder="(label ? label : placeholder)"
        v-model="inputValue"
        v-on:focus="setActive"
        v-on:blur="unsetActive" />

      <button
        v-if="hasPasswordToggle"
        type="button"
        class="text-input__toggle"
        :aria-label="toggleLabel"
        :aria-pressed="revealed ? 'true' : 'false'"
        @click="togglePassword">
        <span>{{ toggleLabel }}</span>
      </button>
    </div>
    <transition name="fade">
      <p v-if="dirty && !isValid" class="form-row__error__text-error text-error"><span>{{resolvedError}}</span></p>
    </transition>
  </div>`
})
